
(() => {
  const set = window.$cookies.set;
  window.$cookies.set = (name, value) => {
    if (name === 'userRights') {
      window.localStorage.setItem(name, value);
      return;
    }
    return set(name, value);
  };

  const get = window.$cookies.get;
  window.$cookies.get = (name) => {
    if (name === 'userRights') {
      return window.localStorage.getItem(name);
    }
    return get(name);
  }
})();



// WEBPACK FOOTER //
// ./src/cookieProxy.js